import React from 'react';
import clsx from 'clsx';
import { Paper, makeStyles } from '@material-ui/core';
import './Index.css';
import LockIcon from '@material-ui/icons/Lock'
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function Index() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
        <>
            <div className="employerIndex">
                <Helmet>
                    <meta name="description" content="Retailer Dashboard" />
                    <title>Dashboard | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <div className="employerIndex__headRow">
                        <h5 className="employerIndex__heading">Let's build Chemist Dashboard</h5>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4 card__height">
                            <div className="card__dashboard">
                                <div className="card__header">
                                    <h5>Level 1</h5>
                                    <h6>Your current level</h6>
                                </div>
                                <hr />
                                <div className="card__body">
                                    <ol>
                                        <li>Free Product Listing</li>
                                        <li>Limited Marketing</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 card__height">
                            <div className="card__dashboard background__color">
                                <div className="card__header">
                                    <h5>Level 2</h5>
                                    <h6>Unlock on 1st March</h6>
                                </div>
                                <hr />
                                <div className="card__body">
                                    <ol>
                                        <li>Lifetime free Billing Software</li>
                                        <li>Inventory management software</li>
                                        <li>Unlimited Event listing & Promotion</li>
                                        <li>Advanced Marketing</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 card__height">
                            <div className="card__dashboard background__color">
                                <div className="card__header">
                                    <h5>Level 3</h5>
                                    <h6></h6>
                                </div>
                                <hr />
                                <div className="card__body card__icon">
                                    <LockIcon fontSize='large' />
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default Index
